import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { PhxDropdownComponent } from './phx-dropdown.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PhxDropdownDirective } from './phx-dropdown.directive';

@NgModule({
  imports: [
    NgCommonModule,
    OverlayModule,
  ],
  declarations: [
    PhxDropdownComponent,
    PhxDropdownDirective,
  ],
  exports: [
    PhxDropdownComponent,
    PhxDropdownDirective,
  ],
})
export class PhxDropdownModule { }
